import { MaskedLine } from "./Reveal";
import { isVideo } from "../lib/site";

const STRIPES = {
  backgroundImage: "repeating-linear-gradient(115deg, transparent 0 26px, rgba(255,255,255,0.6) 26px 27px)",
};

export default function PageHeader({ kicker, title, image, position = "center", children }) {
  return (
    <header className="relative bg-navy pt-40 pb-24 sm:pt-48 sm:pb-32 overflow-hidden">
      {image ? (
        <>
          {isVideo(image) ? (
            <video
              autoPlay
              muted
              loop
              playsInline
              style={{ objectPosition: position }}
              className="absolute inset-0 w-full h-full object-cover opacity-30"
            >
              <source src={image} type="video/mp4" />
              <source src={image.replace(/\.mp4$/i, ".webm")} type="video/webm" />
            </video>
          ) : (
            <img
              src={image}
              alt=""
              style={{ objectPosition: position }}
              className="absolute inset-0 w-full h-full object-cover opacity-30"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-b from-navy/60 via-navy/40 to-navy" />
        </>
      ) : (
        <div className="absolute inset-0 opacity-[0.07]" style={STRIPES} aria-hidden="true" />
      )}
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-center gap-4 mb-5">
          <span className="h-px w-12 bg-rouge" />
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-white/70">{kicker}</span>
        </div>
        <h1 className="font-heading uppercase font-semibold tracking-tighter leading-[0.92] text-5xl sm:text-7xl lg:text-8xl text-white">
          <MaskedLine>{title}</MaskedLine>
        </h1>
        {children}
      </div>
    </header>
  );
}
